import React, { useCallback, useEffect, useState } from "react";
import isEmpty from "lodash.isempty";
import get from "lodash.get";
import { useLocation } from "react-router-dom";

import Context from "./Context";
import { useLiff } from "providers/Liff";
import * as Client from "api/client";
import { useToast } from "providers/Toast";

import * as Methods from "../../methods";
import { getOALink, sendGASourceEvent } from "../../methods";
import { stage } from "config/const";

async function getClientProfiles(liff) {
  try {
    const profile = await liff.getProfile().catch((error) => {
      console.error(error);
      liff.logout();
      liff.login({ redirectUri: window.location.href });
      return false;
    });
    if (!profile) return { error: true };
    const userId = profile.userId;
    const accessToken = liff.getAccessToken();
    const client = await Client.getCreateCustomer(userId, accessToken);

    if (client.err) return { error: client.message };

    return { client, profile, accessToken, userId };
  } catch (error) {
    return { error };
  }
}

let refreshingClient = false;
const Provider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [client, setClient] = useState({});
  const [profile, setProfile] = useState({});
  const { liff, ready } = useLiff();
  const { danger } = useToast();

  const location = useLocation();

  const validAuth =
    auth.userId && auth.accessToken && !isEmpty(profile) && !isEmpty(client);
  const refreshToken = get(client, "idToken.refreshToken");

  const refreshClient = async () => {
    if (refreshingClient) return;
    refreshingClient = true;
    const { client, profile, accessToken, userId, error } =
      await getClientProfiles(liff);
    refreshingClient = false;
    if (isEmpty(client) || isEmpty(profile) || error) {
      danger("請登入後再試一次");
      return { err: true };
    }

    setProfile(profile);
    setClient(client);

    setAuth({ id: client.id, accessToken, userId, idToken: client.idToken });
    return { err: false };
  };

  const updateClient = (data) => {
    return Client.updateCustomer(auth.userId, auth.idToken, data).then(() =>
      refreshClient()
    );
  };

  const refresh = useCallback(async () => {
    if (!refreshToken) return;
    const newIdToken = await Client.refreshIdToken(refreshToken);
    if (newIdToken.err) {
      console.error(newIdToken.err);
      return;
    }
    setAuth({ ...auth, idToken: newIdToken });
  }, [refreshToken]);

  useEffect(() => {
    if (!liff || !ready) return;

    if (location.pathname === "/home") sendGASourceEvent("/home");

    if (!liff.isInClient() || !Methods.isMobile()) {
      if (stage === "local") {
        setTimeout(() => {
          console.log(getOALink());
        }, 500);
      } else {
        setTimeout(() => {
          window.location.href = getOALink();
        }, 500);
        return;
      }
    }

    if (!liff.isLoggedIn()) {
      return liff.login({ redirectUri: window.location.href });
    }
    refreshClient();
  }, [liff, ready]);

  const props = {
    auth,
    profile,
    client,
    validAuth,
    refresh,
    refreshClient,
    updateClient,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
